import { RichTextInput, Stack, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const getNameById = (ownerAccountId) => {
    const user = [
        {
            owner_account_id: '1',
            first_name: 'Georgina',
            last_name: 'Watson',
        },
    ].find(({ owner_account_id }) => owner_account_id === ownerAccountId);
    return getUserPreferredFullName(user);
};

const RichTextInputDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>RichTextInput</Text>
            <Stack spacing={4}>
                <Stack spacing={1}>
                    <Text>Uncontrolled</Text>
                    <RichTextInput onChangeFile={console.log} onSend={console.log} />
                </Stack>
                <Stack spacing={1}>
                    <Text>Uncontrolled with defaultValue and custom placeholder</Text>
                    <RichTextInput
                        defaultValue={'Hello World!'}
                        placeholder={'Custom Placeholder'}
                        onChangeFile={console.log}
                        onSend={console.log}
                    />
                </Stack>
                <Stack spacing={1}>
                    <Text>Uncontrolled with formatting hidden by default</Text>
                    <RichTextInput defaultShowFormatting={false} onChangeFile={console.log} onSend={console.log} />
                </Stack>
                <Stack spacing={1}>
                    <Text>Disabled</Text>
                    <RichTextInput disabled onSend={console.log} />
                </Stack>
                <Stack spacing={1}>
                    <Text>Only disable file upload</Text>
                    <RichTextInput disableUpload onSend={console.log} />
                </Stack>
                <Stack spacing={1}>
                    <Text>With file</Text>
                    <RichTextInput
                        files={[
                            {
                                id: '1',
                                active: true,
                                data: {
                                    name: 'Filename.doc',
                                    type: 'application/msword',
                                },
                            },
                        ]}
                        onChangeFile={console.log}
                        onSelect={console.log}
                        onSend={console.log}
                    />
                </Stack>
                <Stack spacing={1}>
                    <Text>With reply</Text>
                    <RichTextInput
                        isReplyingTo={{
                            id: '1',
                            owner_account_id: '1',
                            text: '<p>The <strong>quick</strong> <em>brown</em> <u>fox</u> <code>jumps</code> over the lazy dog</p>',
                        }}
                        onChangeFile={console.log}
                        onClickCancelReply={console.log}
                        getNameById={getNameById}
                        onSend={console.log}
                    />
                </Stack>
            </Stack>
        </>
    );
};

export default RichTextInputDemo;
